import React from "react";
import { BRAND } from "@/data/tours";

export default function WhatsAppFloat() {
  return (
    <a
      href={BRAND.whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Написать в WhatsApp"
      className="fixed z-40 bottom-20 sm:bottom-6 left-4 sm:left-6 inline-flex items-center gap-3 rounded-full bg-[#25D366] text-white pl-3 pr-5 py-3 shadow-lg animate-soft-pulse hover:scale-105 transition"
    >
      <svg viewBox="0 0 32 32" className="h-6 w-6 fill-current" aria-hidden="true">
        <path d="M19.11 17.32c-.28-.14-1.63-.8-1.88-.89-.25-.09-.44-.14-.62.14-.19.28-.72.89-.88 1.07-.16.19-.32.21-.6.07-.28-.14-1.17-.43-2.22-1.36-.82-.73-1.37-1.63-1.53-1.91-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.48.14-.16.19-.28.28-.46.09-.19.05-.35-.02-.49-.07-.14-.62-1.5-.85-2.05-.22-.53-.45-.46-.62-.47-.16-.01-.35-.01-.53-.01-.19 0-.49.07-.75.35-.26.28-.99.97-.99 2.36 0 1.39 1.01 2.74 1.15 2.93.14.19 1.99 3.04 4.83 4.26.68.29 1.2.46 1.61.59.68.22 1.29.19 1.78.12.54-.08 1.63-.67 1.86-1.31.23-.65.23-1.2.16-1.31-.07-.11-.25-.18-.52-.32zM16.01 4C9.38 4 4 9.38 4 16.01c0 2.12.56 4.11 1.53 5.85L4 28l6.29-1.5c1.68.89 3.6 1.4 5.72 1.4C22.63 27.9 28 22.52 28 15.89 28 9.27 22.63 4 16.01 4z"/>
      </svg>
      <span className="hidden sm:inline text-sm font-semibold">Написать в WhatsApp</span>
    </a>
  );
}
